module.exports = __webpack_public_path__ + "img/close.23a79f30.svg";